module.exports = __webpack_public_path__ + "img/noData.457bd1fb.png";